import React, { Fragment, useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  CardImg,
  ButtonGroup,
  Badge,
} from 'reactstrap';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import {
  postAPI_Compendium_ResetPassword,
  API_Ingetration_Channels,
  aPI_Contacts,
} from '../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import ContactDetails from './contactDetails';
import moment from 'moment';
import { connect } from 'react-redux';
import ContactForm from './contactForm';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { fetchServiceRequest } from '../../../../../redux/service/actions';
import ImageGallery from '../../propinfo/gallery/index';
import IntlMessages from '../../../../../helpers/IntlMessages';
import SendMessagePanel from '../../Guest Messaging/reservation/components/SendMessagingManually/SendMessagePanel';
import { NavLink, withRouter } from 'react-router-dom';
import { getTagsFromContacts, normalizeTags } from '../utils/contactTags';

function ContactInfo({
  propertyId,
  chatListApp,
  match,
  item,
  serviceProvider,
  featuresUrl,
  fetchServiceRequest,
  history,
}) {
  const contactId = match.params.id;
  const [editContact, setEditContact] = useState(false);
  const [note, setNote] = useState('');
  const [contact, setContact] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedChat, setSelectedChat] = useState();
  const [integrations, setIntegrations] = useState([]);
  const [updateModal, setUpdateModal] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [passwordDetails, setPasswordDetails] = useState({
    password: '',
    confirmPassword: '',
  });
  const [activeMessageTab, setActiveMessageTab] = useState('sms');
  const [showSendMessage, setShowSendMessage] = useState(false);
  const isSmsEnabled = integrations.some(
    (i) => i.channel === 'Sms' && i.disabled === false
  );
  const isWhatsAppEnabled = integrations.some(
    (i) => i.channel === 'WhatsApp' && i.disabled === false
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tags, setTags] = useState([]);

  const getBackSearch = () => {
    const tab = new URLSearchParams(window.location.search).get('tab');

    if (tab === 'members' || tab === 'Compendium') return '?tab=members';
    if (tab === 'visitors') return '?tab=visitors';

    return contact?.channel === 'Compendium' ? '?tab=members' : '?tab=visitors';
  };

  const openSendMessagePanel = (tab = 'sms') => {
    setActiveMessageTab(tab);
    setShowSendMessage(true);
  };
  const closeSendMessagePanel = () => {
    setShowSendMessage(false);
  };

  const formatMemberDate = (date) =>
    date && moment(date).isValid() ? moment(date).format('MMM DD, YYYY') : '';

  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);
  useEffect(
    (propertyId) => {
      const callApi = async () => {
        if (contactId !== undefined && contactId !== '') {
          await handleContactLoad();
        }
        await LoadMemberTags();
        await LoadIntegrations();
      };
      callApi();
    },
    [propertyId]
  );
  useEffect(
    (props) => {
      if (selectedChat?.conversationId) {
        if (
          selectedChat?.conversationId !==
          chatListApp?.selectedchat?.conversationId
        ) {
          setSelectedChat(chatListApp?.selectedchat);
        }
      } else setSelectedChat(chatListApp?.selectedchat);
    },
    [chatListApp]
  );
  const toggleModal = () => {
    setUpdateModal(false);
    setPasswordDetails({
      password: '',
      confirmPassword: '',
    });
  };

  const handleUpdatePassword = () => {
    if (passwordDetails.password !== '') {
      if (passwordDetails.password === passwordDetails.confirmPassword) {
        let data = {
          username: contact?.email,
          propertyId: propertyId,
          groupId: getGroupID(),
          password: passwordDetails.password,
          creator: 'Admin',
        };
        AxiosAPI({
          method: 'put',
          url: `${postAPI_Compendium_ResetPassword}`,
          data: data,
        }).then((res) => {
          NotificationManager.success(
            '',
            'Password updated sucessfully.',
            3000,
            null,
            null,
            'error'
          );
          toggleModal();
        });
      } else {
        NotificationManager.error(
          '',
          'Password and current password both are not matched',
          3000,
          null,
          null,
          'error'
        );
      }
    } else {
      NotificationManager.error(
        '',
        'Password can`t be empty.',
        3000,
        null,
        null,
        'error'
      );
    }
  };

  const handleContactLoad = async () => {
    const contactResponse = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}/${contactId}`,
    });
    if (contactResponse.data !== undefined && contactResponse.data?.contactId) {
      setContact(contactResponse.data);
    }
  };

  const LoadMemberTags = async () => {
    const response = await AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}?groupId=${getGroupID()}&propertyId=${propertyId}&search=&pageNumber=1&pageSize=1000&type=Compendium`,
    });

    setTags(getTagsFromContacts(response.data?.contacts || []));
  };

  const handlePassword = (e) =>
    setPasswordDetails({ ...passwordDetails, [e.target.name]: e.target.value });

  const LoadIntegrations = async () => {
    setIsLoading(true);
    let body = {
      channels: [
        'WebsiteDirectLine',
        'FacebookDirectLine',
        'WhatsApp',
        'EmailDirectLine',
        'Sms',
        'Instagram',
        'TeamsApp',
      ],
    };
    const response = await AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    });
    if (response.data.length > 0) {
      const webIntegrationData = response.data.filter(
        (k) =>
          (k.channel === 'WebsiteDirectLine' ||
            k.channel === 'FacebookDirectLine' ||
            k.channel === 'WhatsApp' ||
            k.channel === 'EmailDirectLine' ||
            k.channel === 'Sms' ||
            k.channel === 'Instagram' ||
            k.channel === 'TeamsApp') &&
          k.properties.filter((f) => f === propertyId).length > 0
      );
      setIntegrations(webIntegrationData);
    } else {
    }
  };

  const selectedImage = (image) => {
    // setpropertyData({
    //   ...propertyData,
    //   images: image.src,
    // });
  };

  const toggle = () => setEditContact(!editContact);

  const handleEdit = (body) => {
    AxiosAPI({
      method: 'put',
      url: `${aPI_Contacts}/${contactId}`,
      data: body,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      toggle();
      handleContactLoad();
    });
  };

  const handleSaveNotes = () => {
    if (note !== '') {
      AxiosAPI({
        method: 'put',
        url: `${aPI_Contacts}/notes/${contactId}`,
        data: { note: note },
      }).then((res) => {
        setNote();
        handleContactLoad();
      });
    }
  };

  const handleDelete = async () => {
    try {
      const url = `${aPI_Contacts}/${contactId}`;
      const response = await AxiosAPI({
        method: 'delete',
        url,
      });
      NotificationManager.success(
        '',
        'Contact deleted successfully.',
        3000,
        null,
        null,
        'success'
      );
      setShowDeleteModal(false);
      history.push(`/app/pages/members${getBackSearch()}`);
    } catch (err) {
      NotificationManager.error(
        '',
        'Failed to delete contact. Please try again.',
        3000,
        null,
        null,
        'error'
      );
      setShowDeleteModal(false);
    }
  };

  return (
    <Fragment>
      {contact !== undefined && (
        <Row style={{ marginLeft: '-2%', marginRight: '0%' }}>
          <Colxx xxs="12" md="3" className="mb-2 col-sm-12 col-md-3 pr-0">
            <Card
              className="d-flex flex-row mb-2"
              style={{ borderRadius: '10px', maxWidth: '100%' }}
            >
              <CardBody>
                <div className="mb-3">
                  <NavLink
                    to={{
                      pathname: '/app/pages/members',
                      search: getBackSearch(),
                    }}
                  >
                    <h1 className="iconsminds-back p-0 m-0" />
                  </NavLink>
                  <Colxx md="12" className="mb-2">
                    <div className="user-info">
                      <div className="d-flex justify-content-center">
                        {contact?.channel === 'Compendium' &&
                          contact?.profile ? (
                          <div className="">
                            <img
                              src={`data:image/jpeg;base64,${contact?.profile}`}
                              style={{
                                borderRadius: '50%',
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover',
                              }}
                            ></img>
                          </div>
                        ) : (
                          <div className="contact-round-name">
                            <i className="simple-icon-user"></i>
                          </div>
                        )}
                      </div>
                    </div>
                  </Colxx>
                  <div className="d-flex justify-content-center mb-2">
                    <h4 className="mr-0">
                      {contact?.name !== '' ? contact?.name : 'Unknown'}
                    </h4>
                  </div>
                  <Colxx md="12" className="p-0">
                    <Card className="mb-2 p-3" style={{ borderRadius: '20px' }}>
                      <div className="d-flex mb-2">
                        <p
                          className="mb-0 mr-0"
                          style={{ wordBreak: 'break-all' }}
                        >
                          <i
                            className={`simple-icon-phone`}
                            style={{
                              marginLeft: '0.2em',
                              marginRight: '0.2em',
                            }}
                          ></i>{' '}
                          Phone : {contact?.phone}
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-at-sign`}></i> Email :{' '}
                          {contact?.email}
                        </p>
                      </div>
                      {contact?.channel === 'Compendium' &&
                        contact?.membershipId && (
                          <div className="d-flex mb-2">
                            <p className="mb-0 mr-0">
                              <i className={`iconsminds-id-card`}></i>{' '}
                              Membership Id : {contact?.membershipId}
                            </p>
                          </div>
                        )}
                      {contact?.channel === 'Compendium' &&
                        contact?.dateOfBirth && (
                          <div className="d-flex mb-2">
                            <p className="mb-0 mr-0">
                              <i className={`iconsminds-calendar-4`}></i> Date
                              of Birth : {formatMemberDate(contact.dateOfBirth)}
                            </p>
                          </div>
                        )}
                      {contact?.channel === 'Compendium' &&
                        contact?.joiningDate && (
                          <div className="d-flex mb-2">
                            <p className="mb-0 mr-0">
                              <i className={`iconsminds-calendar-4`}></i>{' '}
                              Joining Date : {formatMemberDate(contact.joiningDate)}
                            </p>
                          </div>
                        )}
                      {contact?.channel === 'Compendium' &&
                        normalizeTags(contact?.tags).length > 0 && (
                          <div className="d-flex mb-2">
                            <p className="mb-0 mr-0">
                              <i className={`iconsminds-tag`}></i> Tags :{' '}
                              {normalizeTags(contact?.tags).map((tag) => (
                                <Badge
                                  color="secondary"
                                  className="mt-1 mr-1"
                                  key={tag}
                                >
                                  {tag}
                                </Badge>
                              ))}
                            </p>
                          </div>
                        )}
                      {/* <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`simple-icon-calendar`}></i> Signed Up : {contact?.signUp}
                        </p>
                      </div> */}
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-calendar-4`}></i> First
                          Activity : {contact?.firstActivity}
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i className={`iconsminds-calendar-4`}></i> Last
                          Activity : {contact?.lastActivity}
                        </p>
                      </div>
                      <div className="d-flex mb-2">
                        <p className="mb-0 mr-0">
                          <i
                            className={`simple-icon-settings`}
                            style={{
                              marginLeft: '0.2em',
                              marginRight: '0.2em',
                            }}
                          ></i>{' '}
                          Last Channel : {contact?.lastChannel}
                        </p>
                      </div>
                      {contact?.consent && (
                        <div className="d-flex mb-2">
                          <p className="mb-0 mr-0">
                            <i className="iconsminds-yes"></i>{' '}
                            <IntlMessages id="dashboards.marketingconsent" />
                            {' : '}
                            {contact.consent === 'Yes' ? (
                              <b style={{ color: 'green' }}>
                                {contact.consent}
                              </b>
                            ) : (
                              <b style={{ color: 'red' }}>{contact.consent}</b>
                            )}{' '}
                          </p>
                        </div>
                      )}
                      {selectedChat?.visitor && (
                        <Fragment>
                          {selectedChat?.visitor?.location && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className={`iconsminds-location-2`}></i>{' '}
                                Location : {selectedChat?.visitor.location}
                              </p>
                            </div>
                          )}
                          {selectedChat?.visitor?.deviceType && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className="iconsminds-computer"></i> Device :{' '}
                                {selectedChat?.visitor.deviceType}
                              </p>
                            </div>
                          )}
                          {selectedChat?.visitor?.browser && (
                            <div className="d-flex mb-2">
                              <p className="mb-0 mr-0">
                                <i className="iconsminds-optimization"></i>{' '}
                                Browser : {selectedChat?.visitor.browser}
                              </p>
                            </div>
                          )}
                        </Fragment>
                      )}
                      {contact.additionalInfo !== undefined &&
                        contact.additionalInfo !== null && (
                          <Fragment>
                            {contact?.additionalInfo?.groupName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i
                                    className={`iconsminds-business-man-woman`}
                                  ></i>{' '}
                                  Group Name :{' '}
                                  {contact?.additionalInfo.groupName}
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.businessName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i
                                    className={`iconsminds-chrysler-building`}
                                  ></i>{' '}
                                  Business Name :{' '}
                                  {contact?.additionalInfo.businessName}
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.propertyName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i className={`iconsminds-building`}></i>{' '}
                                  Property Name :{' '}
                                  {contact?.additionalInfo.propertyName}
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.chainName && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i className={`iconsminds-solar`}></i> Chain
                                  Name : {contact?.additionalInfo.chainName}
                                </p>
                              </div>
                            )}
                            {contact?.additionalInfo?.userType && (
                              <div className="d-flex mb-2">
                                <p className="mb-0 mr-0">
                                  <i className={`iconsminds-user`}></i> User
                                  Type : {contact?.additionalInfo.userType}
                                </p>
                              </div>
                            )}
                          </Fragment>
                        )}
                      {contact?.channel === 'Compendium' && (
                        <Colxx md="12" className="p-0 my-2">
                          <div
                            style={{
                              display: 'flex',
                              marginBottom: '10px',
                              flexWrap: 'wrap',
                              alignItems: 'center',
                              gap: '8px',
                            }}
                          >
                            <span
                              className="contact-details-edit"
                              onClick={toggle}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                padding: '4px 8px',
                              }}
                            >
                              <i className="simple-icon-pencil pr-1" />
                              Edit
                            </span>
                            <Button
                              color="primary"
                              outline
                              size="xs"
                              onClick={() => setUpdateModal(true)}
                            >
                              Reset Password
                            </Button>
                            <Button
                              color="primary"
                              outline
                              size="xs"
                              onClick={() => setShowDeleteModal(true)}
                            >
                              Delete
                            </Button>
                          </div>
                          {showDeleteModal && (
                            <Modal
                              isOpen={showDeleteModal}
                              toggle={() => setShowDeleteModal(false)}
                              style={{ marginTop: '15vh' }}
                              backdrop="static"
                            >
                              <div className="modal-header">
                                <h5 className="modal-title">Confirm Delete</h5>
                                <button
                                  type="button"
                                  className="close"
                                  onClick={() => setShowDeleteModal(false)}
                                >
                                  <span>&times;</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <center>
                                  Are you sure you want to delete this contact?
                                  <br />
                                  <br />
                                  <b>
                                    This action will permanently delete the
                                    contact and it won't be visible anymore.
                                  </b>
                                  <br />
                                  <br />
                                  Please ensure this contact is not being used.
                                </center>
                              </div>
                              <div className="modal-footer d-flex justify-content-center">
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={() => setShowDeleteModal(false)}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={handleDelete}
                                >
                                  Yes, Delete
                                </Button>
                              </div>
                            </Modal>
                          )}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              flexWrap: 'wrap',
                            }}
                          >
                            {isSmsEnabled && (
                              <Button
                                color="primary"
                                size="xs"
                                outline
                                onClick={() => openSendMessagePanel('sms')}
                              >
                                Send SMS
                              </Button>
                            )}
                            {isWhatsAppEnabled && (
                              <Button
                                color="primary"
                                size="xs"
                                outline
                                onClick={() => openSendMessagePanel('whatsapp')}
                              >
                                Send WhatsApp
                              </Button>
                            )}
                          </div>
                        </Colxx>
                      )}
                    </Card>
                  </Colxx>
                </div>

                {/* </Card> */}
                <Colxx md="12" className="p-0">
                  <Card className="mb-2 p-3" style={{ borderRadius: '20px' }}>
                    <div className="mb-3">
                      <Input
                        type="textarea"
                        onChange={(e) => setNote(e.target.value)}
                        style={{ height: '50px' }}
                        placeholder="Add Note"
                      ></Input>
                    </div>
                    {note !== '' && (
                      <Fragment>
                        <div className="d-flex">
                          <div className="col-md-6 mb-2">
                            <Button
                              color="secondary"
                              className="mr-3"
                              size="xs"
                              style={{ width: '100%' }}
                              onClick={() => setNote('')}
                            >
                              Cancel
                            </Button>
                          </div>
                          <div className="col-md-6 mb-2 ml-2">
                            <Button
                              color="primary"
                              size="xs"
                              style={{ width: '100%' }}
                              onClick={handleSaveNotes}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Fragment>
                    )}
                    <div className="mb-2">
                      <div className="contact-notes-body">
                        <ul className="list-group">
                          {contact?.notes &&
                            contact.notes.length > 0 &&
                            contact.notes.map((m) => (
                              <div className="mt-2 mb-2  details-subheading">
                                <b className="mb-2 d-flex">
                                  {moment(m.date).format(
                                    'MMMM Do YYYY, h:mm:ss a'
                                  )}
                                </b>
                                <p
                                  className="mb-2 d-flex"
                                  style={{ color: 'black' }}
                                >
                                  {m.text}
                                </p>
                              </div>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </Card>
                </Colxx>
              </CardBody>
            </Card>
          </Colxx>
          <Colxx xxs="12" md="9" className="mb-2 col-sm-12 col-md-9 pr-0">
            {integrations.length > 0 ? (
              <ContactDetails
                contactId={contactId}
                contact={contact}
                integrationData={integrations.length > 0 ? integrations : []}
                featuresUrl={featuresUrl}
              ></ContactDetails>
            ) : null}
          </Colxx>
        </Row>
      )}
      <Modal
        isOpen={updateModal}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>Reset Password</ModalHeader>
        <ModalBody className="p-3">
          {' '}
          <Form className="text-left">
            <FormGroup className="mb-2">
              <Label>Password</Label>
              <Input
                type="password"
                name="password"
                onChange={handlePassword}
                value={passwordDetails?.password}
                placeholder="Password"
              />
            </FormGroup>
            <FormGroup className="mb-4">
              <Label>Confirm Password</Label>
              <Input
                type="password"
                name="confirmPassword"
                onChange={handlePassword}
                value={passwordDetails?.confirmPassword}
                placeholder="Confirm Password"
              />
            </FormGroup>
            <Separator />
            <Colxx md="12" className="d-flex justify-content-center">
              <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => handleUpdatePassword()}
                >
                  <IntlMessages id="dashboards.save" />
                </Button>
                <Button size="sm" color="dark" outline onClick={toggleModal}>
                  <IntlMessages id="pages.cancel" />
                </Button>
              </ButtonGroup>
            </Colxx>
          </Form>
        </ModalBody>
      </Modal>
      {editContact === true && (
        <ContactForm
          toggle={toggle}
          visible={editContact}
          item={contact}
          propertyId={propertyId}
          taglist={tags}
          handleSubmit={handleEdit}
        ></ContactForm>
      )}
      {showSendMessage && (
        <SendMessagePanel
          activeTab={activeMessageTab}
          onClose={closeSendMessagePanel}
          propertyId={propertyId}
          source="Members"
          recipientId={contactId}
          showPhoneNumber={true}
          showTabs={false}
          showTitle={false}
          preFillPhoneNumber={contact?.phone}
          reservationData={{
            firstName: contact?.name?.split(' ')[0] || '',
            lastName: contact?.name?.split(' ').slice(1).join(' ') || '',
            phone: contact?.phone || '',
            email: contact?.email || '',
          }}
        />
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ chatListApp, settings, service }) => {
  const { propertyId, timeZone, locale, email, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    chatListApp,
    propertyId,
    timeZone,
    locale,
    email,
    serviceProvider,
    featuresUrl,
  };
};
export default withRouter(
  connect(mapStateToProps, { fetchServiceRequest })(ContactInfo)
);
